import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for   DeleteOpenPositionvalues
export const DeleteOpenPositionvalues = createSlice({
  name: "DeleteOpenPositionvalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    DeleteOpenPositionvalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_DeleteOpenPositionvalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_DeleteOpenPositionvalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    DeleteOpenPositionvalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_DeleteOpenPositionvalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchDeleteOpenPositionvalues:(state)=>{
        state.switch = false
    }
  },
});
export default DeleteOpenPositionvalues.reducer;
export const {
  DeleteOpenPositionvalues_datagrid,
  success_api_call_DeleteOpenPositionvalues_datagrid,
  failure_api_call_DeleteOpenPositionvalues_datagrid,
  create_DeleteOpenPositionvalues_datagrid_complete_api,
  DeleteOpenPositionvalues_datagrid_is_success,false_switchDeleteOpenPositionvalues
} = DeleteOpenPositionvalues.actions;
